import { render, staticRenderFns } from "./RecVerify.vue?vue&type=template&id=57e4d75e"
import script from "./RecVerify.vue?vue&type=script&lang=js"
export * from "./RecVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports